module.exports = __webpack_public_path__ + "img/analyse.c73cb6af.jpg";